export const PaywallGradientFooterLine: React.FC = () => {
  return <div className="h-[1px] bg-gradient-to-r from-white via-[#EAECF5] to-white mt-2.5"></div>;
};
